import email from './email/store';
import sms from './sms/store';

export default {
  namespaced: true,
  modules: { email, sms },
};
